import { Component } from '@angular/core';
import {AnimationItem} from "lottie-web";
import {AnimationOptions} from "ngx-lottie";

@Component({
  selector: 'brt-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  logoAnimation!: AnimationItem;
  allowLogoAnimationHover = false;

  animationOptions: AnimationOptions = {
    loop: false,
    autoplay: false,
    path: '/assets/lottie-animations/BFR_Logo.json'
  }


  onLogoAnimCreated($event: AnimationItem) {
    this.logoAnimation = $event;
    this.logoAnimation.playSegments([0, 75], true);
    setTimeout(() => {
      this.allowLogoAnimationHover = true;
    }, 2000);
  }

  onLogoMouseEnter() {
    if(this.allowLogoAnimationHover) {
      const currentFrame = this.logoAnimation.currentFrame;
      let startFrame = 90;
      if(currentFrame === 74 || currentFrame === 189) { // 74 is last frame of in animation; 189 is last frame of hover animation
        this.logoAnimation.playSegments([startFrame, 280], true);
      }
    }

  }
}
